module.exports = __webpack_public_path__ + "img/coin-right.05a1f2a3.svg";